import { PropsWithChildren, useEffect, useRef, useState } from "react";
import { DashboardSliderProps } from "./types";
import { Carousel } from "antd";
import { CarouselRef } from "antd/es/carousel";
import { ReactComponent as SimpleArrowIcon } from "assets/images/icons/simple-arrow.svg";
import classNames from "classnames";

export const DashboardSlider: React.FC<
  PropsWithChildren<DashboardSliderProps>
> = ({ children, className, widgetWidth }) => {
  const carouselRef = useRef<CarouselRef | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [slidesToShow, setSlidesToShow] = useState<number | undefined>();

  useEffect(() => {
    const observeTarget = containerRef.current;
    const resizeObserver = new ResizeObserver((entries) => {
      // Assuming you want to track the dimensions of the first observed entry
      const { width } = entries[0].contentRect;

      setSlidesToShow(width / widgetWidth);
    });

    if (observeTarget) {
      resizeObserver.observe(observeTarget);
    }

    // Cleanup function to unobserve when the component unmounts
    return () => {
      if (observeTarget) {
        resizeObserver.unobserve(observeTarget);
      }
    };
  }, [carouselRef, widgetWidth]);

  return (
    <div ref={containerRef} className={classNames(className)}>
      <Carousel
        ref={
          carouselRef
            ? (ref) => {
                carouselRef.current = ref;
              }
            : undefined
        }
        dotPosition="bottom"
        appendDots={() => (
          <>
            <div className="ml-5 flex flex-row">
              <SimpleArrowIcon
                className="mr-3 h-6 w-6 cursor-pointer stroke-black"
                onClick={() => carouselRef.current?.prev()}
              />
              <SimpleArrowIcon
                className="h-6 w-6 rotate-180 cursor-pointer stroke-black"
                onClick={() => carouselRef.current?.next()}
              />
            </div>
          </>
        )}
        className="flex p-2 pl-6 pr-10"
        infinite={false}
        rows={1}
        slidesToShow={slidesToShow}
        swipeToSlide
        draggable
      >
        {children}
        <div className="w-[20px]" />
      </Carousel>
    </div>
  );
};
